.panelYearly {
    grid-template-columns: 250px 1fr;
    grid-template-rows: minmax(66px, auto);
}
